<template>
  <div style="padding-top: .98rem">
    <topbar :hideBackBtn="true" :text="title"></topbar>
    <!--申请主题,单位名称,单位营业执照,申请人姓名,申请人手机号,个人资质（非必填
    subject,  organizationName,  businessLicense,  applicantName,  applicantMobile,  personalQualification
    -->
    <div class="itemBox">
      <div class="name">申请主题</div>
      <input type="text" placeholder="请输入申请主题" v-model="form.subject">
    </div>
    <div class="itemBox">
      <div class="name">姓名</div>
      <input type="text" placeholder="请输入申请人姓名" v-model="form.applicantName">
    </div>
    <div class="itemBox">
      <div class="name">手机号</div>
      <input type="text" placeholder="请输入申请人手机号" v-model="form.applicantMobile">
    </div>
    <div class="itemBox">
      <div class="name">单位名称</div>
      <input type="text" placeholder="单位名称" v-model="form.organizationName">
    </div>
    <div class="itemBox">
      <div class="name">营业执照</div>
      <!--<input type="text" placeholder="单位营业执照" v-model="form.businessLicense">-->
      <input type="file" @change="onUploadImg">
      <!--<img v-if="form.businessLicense" :src="form.businessLicense" width="200px">-->
    </div>
    <div style="margin-top: 0.1rem;">
      <img v-if="form.businessLicense" :src="form.businessLicense" width="100px">
    </div>
    <div v-if="form.type === 'COOPERATIVE_ORGANIZATION'" class="itemBox">
      <div class="name">个人资质</div>
      <input type="text" placeholder="个人资质" v-model="form.personalQualification">
    </div>
    <div class="btn" @click="checkForm">提交</div>
  </div>
</template>
<script>
import {getValidApplication, submit} from "@/api/application"
import {applicationTypes} from "@/utils/enums"

import topbar from 'components/topbar'

export default {
  data() {
    return {
      title: '申请表',
      form: {
        type: ''
      },
      canSubmit: false,
      upload: {
        file: null,
        token: ''
      }
    }
  },
  components: { topbar },
  created() {
    if (!this.$utils.checkLogin()) {
      return;
    }
    const type = this.$route.query.type
    if (!type) {
      alert('参数错误: type不能为空')
      return
    }
    const typeLabel = applicationTypes()[type]
    console.log('type=', type, 'typeLabel=', typeLabel)
    if (!typeLabel) {
      alert('参数错误: 申请类型不正确')
      return
    }
    this.title = typeLabel
    this.form.type = type
    this.checkType(type)
  },
  methods: {
    async checkType(type) {
      const res = await getValidApplication(type)
      const existApplication = res.data
      if (!existApplication || existApplication.status === 'REFUSED') {
        this.canSubmit = true
        return
      }
      if (existApplication.status === 'PASSED' && existApplication.content
        && existApplication.content.indexOf('http') >= 0) {
         location.href = existApplication.content
        return
      }
      // alert('已经提交过相同类型的申请')
      this.$router.push('/application_msg')
    },
    checkForm() {
      if (!this.canSubmit) {
        alert('申请尚不能提交')
        return
      }
      if (!this.form.subject) {
        alert('请输入申请主题')
      } else if (!this.form.applicantName) {
        alert(`请输入姓名`)
      } else if (!this.form.applicantMobile) {
        alert(`请输入手机号`)
      } else if (!this.form.organizationName) {
        alert(`请输入单位名称`)
      } else if (!this.form.businessLicense) {
        alert(`请上传营业执照`)
      } else {
        this.doSubmit()
      }
    },
    doSubmit() {
      submit(this.form).then(_ => {
        alert('提交成功')
        this.canSubmit = false
        this.gotoMsg()
      })
    },
    gotoMsg() {
      this.$router.push('/application_msg')
    },
    onUploadImg(e) {
      this.upload.file = e.target.files[0]
      this.getUploadToken(this.doUploadImg)
    },
   async doUploadImg() {
      let formData = new FormData()
      formData.append("token", this.upload.token)
      formData.append("file", this.upload.file)
      let response = await fetch('https://up.qbox.me', {
        method: "POST",
        mode: "cors",
        body: formData
      }).catch((error) => {
        console.log(error)
        alert('上传出错 001')
      })

      let data = await response.json().catch((error) => {
        console.log(error)
        alert('上传出错 002')
      })
      if (data.key) {
        this.form.businessLicense = this.$utils.getImage(data.key)
        console.log(this.form.businessLicense)
      } else {
        alert('上传出错 003')
      }
    },
    getUploadToken(cb) {
      let url = `/bear-scale/api/qiniu/obtainPictureUploadToken.json`
      fetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(x => {
        x.json().then(y => {
          console.log(y)
          if (y.code !== 0) {
            alert('上传出错 004')
            return
          }
          this.upload.token = y.token
          if (cb) cb()
        })
      })
    }
  },
}
</script>
<style scoped>
.itemBox {
  margin-top: .16rem;
  height: .88rem;
  padding: 0 .24rem;
  display: flex;
  align-items: center;
  background: #fff;
}

.name {
  width: 1.5rem;
  font-size: .3rem;
  color: #212121;
  margin-right: .4rem;
}

input {
  border: none;
  font-size: .3rem;
  color: #212121;
}

input::placeholder {
  color: #AEAEAE;
}

input:disabled {
  background: #fff;
}

.send {
  width: 1.52rem;
  height: .54rem;
  background: #00C59F;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .24rem;
  color: #fff;
  border-radius: .06rem;
  margin-left: .1rem;
}

.btn {
  width: 7.02rem;
  height: .8rem;
  border-radius: .1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: .3rem;
  color: #fff;
  margin: 1.5rem auto 0;
  background: #00C59F;
}
</style>



// WEBPACK FOOTER //
// src/components/application/index.vue